import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const useGroupDocumentsQuery = getWrappedUseQuery(KEYS.GET_DOCUMENTS_KEY, apiClient.ForumGroupDocuments.getAll);
